import * as React from 'react';
import { ICopywriter } from './Entities';
import CopywritersListRow from './CopywritersListRow';
import { Translate } from '../../shared/LanguageService';

interface ICopywritersListProps {
    copywriters: ICopywriter[];
    editCopywriters: (id: number) => void;
    viewlogs: (id: number) => void;
    deleteCopywriters: (id: number) => void;
}

const CopywritersList = (props: ICopywritersListProps) => {
    return (
        <table className="table table-hover table-responsive">
            <thead>
                <tr>
                    <th>{Translate('copywriter/list/header/name')}</th>
                    <th>{Translate('copywriter/list/header/email')}</th>
                    <th>{Translate('copywriter/list/header/phone')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.copywriters &&
                    props.copywriters
                        .sort((a: ICopywriter, b: ICopywriter) => {
                            if (a.name < b.name) {
                                return -1;
                            }
                            if (a.name > b.name) {
                                return 1;
                            }

                            return 0;
                        })
                        .map((copywriter: ICopywriter, index: number) => {
                            return (
                                copywriter && (
                                    <CopywritersListRow
                                        key={index}
                                        copywriter={copywriter}
                                        editCopywriter={props.editCopywriters}
                                        viewlogs={props.viewlogs}
                                        deleteCopywriter={props.deleteCopywriters}
                                    />
                                )
                            );
                        })}
            </tbody>
        </table>
    );
};

export default CopywritersList;
